import type { ReactNode } from 'react'

/** Classe das células das tabelas de lista. */
export const TD_CLASS = 'whitespace-nowrap px-4 py-2.5 text-body/80'

/**
 * Esqueleto das tabelas de lista do Atendimento HUB e de Ocorrências:
 * rolagem horizontal, cabeçalho em caixa-alta e linhas separadas. Quem usa
 * monta as `<th>` (`SortableTh`/`TH_CLASS`) e as linhas (`ClickableRow`).
 */
export function ListTable({
  head,
  children,
}: {
  head: ReactNode
  children: ReactNode
}) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr className="border-b border-border-subtle text-left text-[11px] uppercase tracking-wide text-subtle">
            {head}
          </tr>
        </thead>
        <tbody className="divide-y divide-border-subtle">{children}</tbody>
      </table>
    </div>
  )
}

/**
 * Linha inteira clicável. Não é `<button>`: uma linha pode conter controles
 * (ex.: select de prioridade do HUB), e HTML não permite interativo dentro de
 * interativo — daí `role="button"` + teclado.
 */
export function ClickableRow({
  onClick,
  children,
}: {
  onClick: () => void
  children: ReactNode
}) {
  return (
    <tr
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        // Só teclas na PRÓPRIA linha: Enter/Espaço num controle dentro dela
        // (ex.: select de prioridade do HUB) não pode abrir a linha.
        if (e.target !== e.currentTarget) return
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
      className="cursor-pointer transition hover:bg-surface-muted focus:bg-surface-muted focus:outline-none"
    >
      {children}
    </tr>
  )
}
